'use strict'

import React from 'react';

import Layout from './Layout.jsx';
import ProjectMenu from './components/ProjectMenu.jsx';
import StatusIndicator from './components/StatusIndicator.jsx';
import Field from './components/Field3.jsx';
import {TitleAndSummary} from './log/HighlightReport.jsx';
import {RiskTable} from './Risk.jsx';
import {IssueTable} from './Change.jsx';
import FormattedContent from './components/FormattedContent.jsx';

import {Access} from './settings/ProjectSettings.jsx';
import getProjectInitiationDocument from '../app/model/getProjectInitiationDocument.js';

import Translations from '../app/utils/translations.js';
let translations=new Translations([
    require('./project/labels/english.js'),
    require('./project/labels/norwegian.js')
]).loadVariants([
  require('./product/labels/english#productDetails.js'),
  require('./product/labels/norwegian#productDetails.js'),
  require('./product/labels/english#releaseDetails.js'),
  require('./product/labels/norwegian#releaseDetails.js')
]);

class LinkDetails extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    var item=this.props;
    switch (this.props.mode) {
      case "editable":
        return (
          <div>
            <a href={"?editLinks=true&deleteLink="+item.id} style={{marginLeft: 0, position: "relative", marginRight: 15}}>
              <span style={{color: "red", position: "absolute", left: -3, top: -1, fontWeight: "bold", fontFamily:"Arial"}}>x</span>
            </a>
            <a href={"?editLinks=true&editLink="+item.id} style={{textDecoration: "none", color:"black", position: "relative"}}>
              <span style={{marginLeft: 0}}>{item.text} </span>
              <img style={{paddingLeft: 5, verticalAlign:"middle"}} src="/icons/pen_grey.jpg"/>
            </a>
          </div>
        );
      case "edit":
        return (
          <div>
            <div style={{marginTop: 10, marginBottom:30, paddingBottom:15}}>
              <form method="POST">
                <input type="hidden" name="id" value={item.id}/>
                <input type="hidden" name="editLinks" value="true"/>
                <input style={{width:"100%", marginBottom:10}} className="input" name="text" autoComplete="off" defaultValue={item.text} placeholder={labels.link.edit.textPlaceholder}/><br/>
                <input style={{width: "100%", marginBottom:10}} className="input" name="link" autoComplete="off" defaultValue={item.link} placeholder={labels.link.edit.addressPlaceholder}/><br/>
                <div style={{float: "right"}}>
                  <input type="submit" className="cancel" name="cancel" value={labels.link.cancel}/> <input type="submit" className="save" value={labels.link.save}/>
                </div>
              </form>
            </div>
          </div>
        );
      default:
        return (
          <div>
            <a href={item.link} target="_blank">{item.text}</a>
          </div>
        );
    }
  }
}

class StandardLinkDetails extends React.Component {
  render() {
    var address=this.props.address;
    var project=this.props.project;
    if (this.props.parameters!==undefined && this.props.parameters.length>0) {
      this.props.parameters.forEach(parameter=>{
        address=address.split("{"+parameter.name+"}").join(project[parameter.key]);
      })
    }
    return <LinkDetails {...this.props} text={this.props.title} link={address} mode="show"/>;
  }
}

class ShowStandardLinks extends React.Component {
  render() {
    return this.props.standardLinks!==undefined ? (
      <div>
        {this.props.standardLinks.map(link=><StandardLinkDetails {...this.props} key={link.id} {...link} project={this.props}/>)}
      </div>
    ) : null;
  }
}

class ShowLinkList extends React.Component {
  render() {
    var edit=this.props.edit;
    var mode=this.props.mode;
    return (this.props.links!==undefined || this.props.standardLinks!==undefined) ? (
        <div style={{marginTop:5, paddingTop:0, paddingLeft:"0.6em", listStyle: "inside", paddingBottom:0, marginBottom:10}}>
          {this.props.hideStandardLinks!==true ? (
            <ShowStandardLinks {...this.props}/>
          ) : null}
          {this.props.links!==undefined ? this.props.links.map(item =>
            <LinkDetails
              {...this.props}
              {...item}
              key={item.id}
              mode={mode==="edit"
                ? (edit===item.id
                  ? "edit"
                  : "editable")
                : "show"}/>
            ) : null}
        </div>
      ) : (
        <div/>
      );
  }
}

class LinkListEditIcon extends React.Component {
  render() {
    return (
      <div style={{display:"inline-block", paddingLeft: 5}}>
        <a href={this.props.url}><img src="/icons/pen_grey.jpg"/></a>
      </div>
    );
  }
}

class AddLink extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    return (this.props.add) ? (
        <LinkDetails {...this.props} mode="edit" id={undefined}/>
      ) : (
        <a href="?editLinks=true&addLink=true" style={{color:"#70B0E6", paddingLeft: 5}}><img style={{height: "0.8em"}} src="/icons/plus_lightblue.jpg"/>{labels.link.add}</a>
      );
  }
}

class DisplayLinks extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    return (this.props.mode==="edit")? (
      <div>
        <b>{labels.link.heading}</b> (<i><a href="?">{labels.link.exitEdit}</a></i>)
        <ShowLinkList {...this.props} mode="edit" edit={this.props.edit} hideStandardLinks={this.props.isProgramme===true}/>
        <AddLink {...this.props} add={this.props.add}/>
      </div>
    ) : (
      <div>
        <b>{labels.link.heading}</b>
        <LinkListEditIcon url="?editLinks=true"/>
        <ShowLinkList {...this.props} hideStandardLinks={this.props.isProgramme===true}/>
      </div>
    );
  }
}

class DisplayProjectDetails extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    var executive=this.props.stakeholders!==undefined ? this.props.stakeholders.filter(stakeholder=>stakeholder.role==="Excecutive").map(person=>person.name).join(", ") : undefined;
    var pManager=this.props.stakeholders!==undefined ? this.props.stakeholders.filter(stakeholder=>stakeholder.role==="Project Manager" || stakeholder.role==="Product Manager").map(person=>person.name).join(", ") : undefined;
    return (
      <div style={{paddingBottom: 15}}>

      {this.props.isProduct===true ? (
        <div>
          <b>{this.props.name}</b> <StatusIndicator {...this.props.overallStatus}/>
        </div>
      ) : null}

        <div style={{paddingLeft:"0.6em"}}>
          {this.props.isProduct!==true ? (
            <div>
              {this.props.phase}
            </div>
          ) : null}
          {this.props.identifier!==undefined && this.props.identifier.trim().length>0 ? (
            <div>
              ID: {this.props.identifier}
            </div>
          ) : null}
          <div>
            {labels.general.executive}: {executive}
          </div>
          <div>
            {labels.general.projectManager}: {pManager}
          </div>
        </div>
      </div>
    );
  }
}

export class Links extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let itemType=
      this.props.isProgramme===true
        ? "/programmes/"
        : this.props.isProduct===true
          ? "/products/"
          : this.props.isRelease===true
            ? "/releases/"
            : "/projects/";
    return (
      <div style={{fontFamily:"Lato", display:"inline-block", float: "right",marginRight: 30, width:250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft:10, paddingBottom: 150}}>
        {this.props.isRelease ?
          <div  style={{paddingBottom:30, textAlign: "left"}}>  <a href={"/products/" + this.props.product.id}> {labels.link.goToProduct} </a></div>
          : null
        }
        <DisplayLinks {...this.props} mode={this.props.mode}/>
        <div style={{paddingTop: 10}}>
          <b>{labels.reports.heading}</b>
            <ul style={{marginTop:5, paddingTop:0, paddingLeft:"0.6em", listStyle: "none", paddingBottom:0, marginBottom:10}}>
              {this.props.isProduct!==true && this.props.endProjectReport!==undefined && (this.props.isCompleted || this.props.isClosing===true)? (
                <li><a href={itemType+this.props.id+"/reports?showEndStage=true&id="+this.props.endProjectReport.id}>{labels.reports.endProjectReport}</a></li>
              ) : null}
              <li><a href={itemType+this.props.id+"/reports/"}>{labels.reports.highlightReport}</a></li>
              {this.props.isProduct!==true && this.props.briefEnabled
                ? <li><a href={itemType+this.props.id+"/brief/"}>{labels.reports.brief}</a></li>
                : null
              }
              {this.props.isProduct!==true && this.props.pidEnabled
                ? <li><a href={itemType+this.props.id+"/pid/"}>{labels.reports.pid}</a></li>
                : null
              }
            </ul>
        </div>
      </div>
    );
  }
}

class ThemeLink extends React.Component {
  render() {
    return this.props.url!==undefined ? (
        <a style={{textDecoration:"none", color: "#378187"}} href={this.props.url}>
          <div style={{textAlign:"center", height:178, width:180, border:"solid 1px #E5E5E5"}}>
            <img style={{paddingTop:40, paddingBottom: 27}} src={this.props.image}/>
            <div style={{textAlign:"center", verticalAlign:"middle", position:"relative", color:"#212121", backgroundColor: "#E5E5E5", padding:16, textDecoration:"none", fontSize:"15pt", fontFamily:"Lato, Verdana, Geneva, sans-serif", fontWeight: "normal"}}>{this.props.labels.title}</div>
          </div>
        </a>
      ) : (
        <img src={this.props.image}/>
      );
  }
}

export class Themes extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let access=this.props.access;
    let itemType=this.props.project.isProgramme===true ? "/programmes/" : this.props.project.isProduct===true ? "/products/" : this.props.project.isRelease===true ? "/releases/" : "/projects/";
    var actions=(this.props.fullOverview!==undefined) ? [
//      {url:"/projects/"+this.props.project.id+"/brief", image:"/images/mandate_s1.png"},
      {name: "definition", url:itemType+this.props.project.id+"/definition", image:"/images/definition.png", labels: labels.themes.definition},
      {name: "businessCase", url:itemType+this.props.project.id+"/businessCase",image:"/images/business_case_s1.png", labels: labels.themes.businessCase},
      {name: "organizaton", url:itemType+this.props.project.id+"/organization?show=approach",image:"/images/organization_s1.png", labels: labels.themes.organization},
      {name: "quality", url:itemType+this.props.project.id+"/quality?show=approach", image:"/images/quality_s1.png", labels: labels.themes.quality},
      {name: "plans", url:itemType+this.props.project.id+"/plan?show=approach", image:"/images/plans_s1.png", labels: labels.themes.plan},
      {name: "risk", url:itemType+this.props.project.id+"/risk?show=approach",image:"/images/risk_s1.png", labels: labels.themes.risk},
      {name: "change", url:itemType+this.props.project.id+"/change?show=approach", image:"/images/change_s1.png", labels: labels.themes.change},
      {name: "progress", url:itemType+this.props.project.id+"/highlight",image:"/images/progress_s1.png", labels: labels.themes.progress}
    ] : [
//      {url:"/projects/"+this.props.project.id+"/brief", image:"/images/mandate_s1.png"},
      access.isDefinitionEnabled()
        ? {name: "definition", url:itemType+this.props.project.id+"/definition", image:"/icons/brief_icon_trans.png", labels: labels.themes.definition}
        : this.props.project.isRelease!==true
          ? {name: "background", url:itemType+this.props.project.id+"/background", image:"/icons/brief_icon_trans.png", labels: labels.themes.background}
          : undefined
        ,
      access.isBusinessCaseEnabled() ? {name: "businessCase", url: itemType+this.props.project.id+"/businessCase",image:"/icons/business_case_icon_trans.png", labels: labels.themes.businessCase} : undefined,
      this.props.project.isRelease!==true && this.props.user!==undefined ? {name: "organization", url:itemType+this.props.project.id+"/organization"+(access.isPIDEnabled() ? "?show=approach" : ""),image:"/icons/organization_icon_trans.png", labels: labels.themes.organization} : undefined,
      access.isQualityEnabled() ? {name: "quality", url:itemType+this.props.project.id+"/quality"+(access.isPIDEnabled() ? "?show=approach" : ""), image:"/icons/quality_icon_trans.png", labels: labels.themes.quality} : undefined,
      this.props.project.isProgramme!==true ? {name: "plans", url:itemType+this.props.project.id+"/plan"+(access.isPIDEnabled() ? "?show=controls" : access.isProjectBriefEnabled() ? "?show=approach" : "?show=lessons"), image:"/icons/plans_icon_trans.png", labels: labels.themes.plan} : undefined,
      {name: "risk", url:itemType+this.props.project.id+"/risk"+(access.isPIDEnabled() ? "?show=approach" : ""),image:"/icons/risk_icon_trans.png", labels: labels.themes.risk},
      {name: "change", url:itemType+this.props.project.id+"/change"+(access.isPIDEnabled() ? "?show=approach" : ""), image:"/icons/change_icon_trans.png", labels: labels.themes.change},
      {name: "progress", url:itemType+this.props.project.id+"/highlight",image:"/icons/progress_icon_trans.png", labels: labels.themes.progress}
    ];
    actions=actions.filter(item=>item!==undefined);
    var max=actions.length>4 ? 4 : actions.length;
    var firstRow=actions.slice(0,max);
    var lastRow=actions.length>max ? actions.slice(max,actions.length) : [];
    let displayActions= actions;

    return this.props.style==="small" || (this.props.project.isProgramme!==true && this.props.project.isProduct!==true && this.props.project.isRelease!==true) ? (
      <div style={{display:"flex", justifyContent:"space-around"}}>
        {displayActions.map(theme=>(
          <a key={theme.name} href={theme.url} style={{textDecoration:"none", width:100/displayActions.length+"%"}}>
            <div key={theme.labels.title} style={{padding:20, textAlign:"center"}}>
              <img src={theme.image}/>
              <div style={{fontFamily:"Lato, Verdana, Geneva, sans-serif", fontSize:"14pt", color:"#212121", textTransform: "capitalize", color: "#378187"}}>
                {theme.labels.title}
              </div>
            </div>
          </a>
        ))}
      </div>
    ) : (
      <tbody>
        <tr>
          {firstRow.map(item=>(
            <td key={item.image}>
              <ThemeLink {...item}/>
            </td>
          ))}
        </tr>
        {lastRow.length>0 ? (
          <tr>
            {lastRow.map(item=>(
              <td key={item.image}>
                <ThemeLink {...item}/>
              </td>
            ))}
          </tr>
        ) :null}
      </tbody>
    );

  }
}

function containFields(object,fields) {
    return fields.reduce((check,item)=>check+(object!==undefined && object[item]!==undefined && object[item].length>0 ? 1 : 0),0);
  }


export class ActivityView extends React.Component {
  render() {
    let labels=this.props.labels;
    let activities=this.props.activities;
    return (
      <div >

       <div style={{padding:"20px 20px 20px 40px", border: "solid 1px #e9e7e6",}}>
        <Field
          labels={this.props.labels}
          name="steps"
          optional={true}
          type="process"
          title={labels.title}
          help={labels.help}
          value={{
            activities: activities,
            nextStep: this.props.nextStep,
            cancel: this.props.cancel
          }}
          project={this.props.project}
        />
        </div>

        <div style={{paddingTop: 25, width:"100%", display: this.props.hideThemes ? "none" : undefined}}>
          <Themes {...this.props} style="small"/>
        </div>
      </div>
    );
  }
}

class StartUpProcessOverview extends React.Component {

  stakeholderCount(roles) {
    return this.props.project.stakeholders!==undefined ? roles.filter(role=>this.props.project.stakeholders.filter(stakeholder=>stakeholder.role===role).length>0).length : 0
  }

  appointedExecutiveAndPM() {
    let count=this.stakeholderCount(["Project Manager","Excecutive"]);
    switch (true) {
      case (count===1): return "inProgress";
      case (count===2): return "done";
      default: return "notStarted";
    }
  }

  appointedManagementTeam() {
    let count=this.stakeholderCount(["Project Manager","Excecutive", "Senior Supplier", "Senior User", "Team Manager"]);
    switch (true) {
      case (count>0 && count<5): return "inProgress";
      case (count===5): return "done";
      default: return "notStarted";
    }
  }

  containFields(object,fields) {
    return fields.reduce((check,item)=>check+(object!==undefined && object[item]!==undefined && object[item].length>0 ? 1 : 0),0);
  }

  preparedBusinessCase() {
    let expectedFields=["executiveSummary","benefits","doSomething","doNothing","reasons","projectPlanSummary","investmentAppraisal","risks"];
    return this.props.project.businessCase!==undefined &&
      containFields(this.props.project.businessCase,expectedFields)===expectedFields.length
        ? "done"
        : this.props.project.businessCase!==undefined
          ? "inProgress"
          : "notStarted";
  }

  definedProject() {
    let expectedFields=["background","timing","bigPicture","benefitsDescription","objectivesSummary","objectives","projectScope","scopeExclusions","outcomes","constraints","assumptions","stakeholderDescription","interfaces"];
    let count=containFields(this.props.project,expectedFields);
    return count>=expectedFields.length-3
      ? "done"
      : count>0
        ? "inProgress"
        : "notStarted";
  }

  describedProjectProduct() {
    let ppd=this.props.project.projectScope;
    return ppd!==undefined && ppd.length>0 && ppd.filter(item=>item.items!==undefined && item.items.length>0).length===ppd.length
      ? "done"
      : ppd!==undefined && ppd.length>0
        ? "inProgress"
        : "notStarted";
  }

  selectedApproach() {
    let expectedFields=["methods","resources","technology","rollOut","other"];
    let count=containFields(this.props.project.approach,expectedFields);
    return this.props.project.approach!==undefined && count>=expectedFields.length-1
      ? "done"
      : this.props.project.approach!==undefined
        ? "inProgress"
        : "notStarted";
  }

  plannedInitiation() {
    return this.props.project.stages!==undefined && this.props.project.stages.length>0 ? "done" : "notStarted";
  }

  capturedLessons() {
    return this.props.project.lessons!==undefined ? "done" : this.props.project.browsedCorporateLessons ? "inProgress" : "notStarted";
  }

  createdBriefDraft() {
    return this.props.project.brief!==undefined && this.props.project.brief.type==="draft" ? "done" : "notStarted";
  }

  render() {
    let labels=translations.getTranslation(this.props).startupProcess;
    let access=this.props.access;
    let activities=[ {
        name:"appointExecutiveAndPM",
        link:"/organization",
        status:this.appointedExecutiveAndPM()
      }, {
        name:"captureLessons",
        link:"/plan?show=approach#lessons",
        status: this.capturedLessons()
      }, {
        name:"appointManagementTeam",
        link: "/organization",
        status: this.appointedManagementTeam()
      }, access.isBusinessCaseEnabled() ? {
        name: "prepareOutlineBusinessCase",
        link: "/businessCase",
        status: this.preparedBusinessCase()
      } : undefined, {
        name: "defineProject",
        link: "/definition",
        status: this.definedProject()
      }, {
        name: "describeProjectProduct",
        link: "/quality/#ppd",
        status: this.describedProjectProduct()
      }, {
        name: "selectApproach",
        link: "/plan?show=approach#planApproach",
        status: this.selectedApproach()
      }, {
        name: "planInitiation",
        link: "/plan?show=approach#schedule",
        status: this.plannedInitiation()
      }, {
        name: "assembleBrief",
        link: "/brief",
        status: this.createdBriefDraft()
      }
    ].filter(item=>item!==undefined);
    let nextStep={
      link: "/projects/"+this.props.project.id+"/brief/?showApprove=true"
    };
    return (
      <ActivityView {...this.props} activities={activities} labels={labels} nextStep={nextStep}/>
    );
  }
}

class InitiationProcessOverview extends React.Component {

  describedRiskManagementApproach() {
    let expectedFields=["process","tools","reporting","timing","roles","tolerance","budget"];
    let count=containFields(this.props.project.riskApproach,expectedFields);
    return this.props.project.riskApproach!==undefined && count>=expectedFields.length-1
      ? "done"
      : this.props.project.riskApproach!==undefined
        ? "inProgress"
        : "notStarted";
  }

  describedQualityManagementApproach() {
    let expectedFields=["process","tools","reporting","timing","roles"];
    let count=containFields(this.props.project.qualityApproach,expectedFields);
    return this.props.project.qualityApproach!==undefined && count>=expectedFields.length-1
      ? "done"
      : this.props.project.qualityApproach!==undefined
        ? "inProgress"
        : "notStarted";
  }

  describedConfigurationManagementApproach() {
    let expectedFields=["process","tools","reporting","timing","roles","scales"];
    let count=containFields(this.props.project.changeControlApproach,expectedFields);
    return this.props.project.changeControlApproach!==undefined && count>=expectedFields.length-1
      ? "done"
      : this.props.project.changeControlApproach!==undefined
        ? "inProgress"
        : "notStarted";
  }

  describedCommunicationManagementApproach() {
    let expectedFields=["process","tools","reporting","timing","roles"];
    let count=containFields(this.props.project.communicationApproach,expectedFields);
    return this.props.project.communicationApproach!==undefined && count>=expectedFields.length-1
      ? "done"
      : this.props.project.communicationApproach!==undefined
        ? "inProgress"
        : "notStarted";
  }

  definedProjectControls() {
    return this.props.project.projectControls!==undefined
      ? this.props.project.projectControls.projectControls!==undefined
        ? "done"
        : "inProgress"
      : "notStarted"
  }

  createdProjectPlan() {
    return this.props.project.stages!==undefined ?
      this.props.project.stages.length>1
        ? "done"
        : "inProgress"
      : "notStarted";
  }

  preparedBusinessCase() {
    let expectedFields=["executiveSummary","benefits","doSomething","doNothing","reasons","projectPlanSummary","investmentAppraisal","risks"];
    return this.props.project.businessCase!==undefined &&
      containFields(this.props.project.businessCase,expectedFields)===expectedFields.length
        ? "done"
        : this.props.project.businessCase!==undefined
          ? "inProgress"
          : "notStarted";
  }

  createdPIDDraft() {
    return this.props.project.pid!==undefined && this.props.project.pid.type==="draft" ? "done" : "notStarted";
  }

  render() {
    let labels=translations.getTranslation(this.props).initiationProcess;
    let access=this.props.access;
    let activities=[ {
        name:"prepareRiskManagementApproach",
        link:"/risk?show=approach#riskManagementApproach",
        status: this.describedRiskManagementApproach()
      }, access.isQualityEnabled() ? {
        name:"prepareQualityManagementApproach",
        link:"/quality?show=approach#qualityManagementApproach",
        status: this.describedQualityManagementApproach()
      } : undefined, {
        name:"prepareConfigurationManagementApproach",
        link: "/change?show=approach#changeControlApproach",
        status: this.describedConfigurationManagementApproach()
      }, {
        name: "prepareCommunicationManagementApproach",
        link: "/organization?show=approach#communicationManagementApproach",
        status: this.describedCommunicationManagementApproach()
      }, {
        name: "setupProjectControls",
        link: "/plan?show=controls#projectControls",
        status: this.definedProjectControls()
      }, {
        name: "createProjectPlan",
        link: "/plan?show=controls#schedule",
        status:  this.createdProjectPlan()
      },  access.isBusinessCaseEnabled() ? {
        name: "refineBusinessCase",
        link: "/businessCase",
        status: this.preparedBusinessCase()
      } : undefined , {
        name: "defineProject",
        link: "/definition",
        status: new StartUpProcessOverview(this.props).definedProject()
      }, {
        name: "describeProjectProduct",
        link: "/quality/#ppd",
        status: new StartUpProcessOverview(this.props).describedProjectProduct()
      }, {
        name: "selectApproach",
        link: "/plan?show=approach#planApproach",
        status: new StartUpProcessOverview(this.props).selectedApproach()
      }, {
        name: "assemblePID",
        link: "/pid",
        status: this.createdPIDDraft()
      }
    ].filter(item=>item!==undefined && !item.disabled);
    let nextStep={
      link: "/projects/"+this.props.project.id+"/pid/?showApprove=true"
    };
    return (
      <ActivityView {...this.props} activities={activities} labels={labels} nextStep={nextStep}/>
    );
  }
}

class CloseProjectProcessOverview extends React.Component {
  createdLessons() {
    return this.props.project.lessons!==undefined ? "done" : "notStarted";
  }

  publishedEndProjectReport() {
    return this.props.project.endProjectReport!==undefined
      ? "done"
      : this.props.project.draftEndProject!==undefined
        ? "inProgress"
        : "notStarted";
  }

  closedRisks() {
    return this.props.project.risks===undefined || this.props.project.risks.filter(item=>item.status!=="Closed").length===0 ? "done" : "notStarted";
  }

  closedIssues() {
    return this.props.project.issues===undefined || this.props.project.issues.filter(item=>item.status!=="Closed").length===0 ? "done" : "notStarted";
  }

  recommendedClosure() {
    return this.props.project.recommendedProjectClosure!==undefined ? "done" : "notStarted";
  }

  render() {
    let labels=translations.getTranslation(this.props).closeProcess;
    let access=this.props.access;
    let activities=[
      {
  /*
        name: "acceptProducts",
        link: "/quality",
        status: "notSupported"
      }, {
  */
        name: "createLessons",
        link: "/plan?show=lessons#lessons",
        status: this.createdLessons()
      }, {
        name: "createEndProjectReport",
        link: this.props.project.endProjectReport===undefined ? "/highlight?endProject=true" : "/reports?showEndStage=true&id="+this.props.project.endProjectReport.id,
        status: this.publishedEndProjectReport()
      }, {
        name: "closeRiskRegister",
        link: "/risk?show=approach",
        status: this.closedRisks()
      }, {
        name: "closeIssueRegister",
        link: "/change?show=approach",
        status: this.closedIssues()
      }, {
        name: "recommendClosure",
        link: "?showMenu=true",
        status: this.recommendedClosure()
      }
    ].filter(item=>item!==undefined);
    let nextStep=this.props.project.recommendedProjectClosure!==undefined ? {
      link: "/projects/"+this.props.project.id+"/approve/close"
    } : undefined;
    return (
      <div  >
        <ActivityView
          {...this.props}
          activities={activities}
          labels={labels}
          nextStep={nextStep}
          cancel={{link:"/projects/"+this.props.project.id+"/abort/close"}}
        />
        {this.props.project.recommendedProjectClosure!==undefined && this.props.project.endProjectReport!==undefined ? (
          <div style={{maxWidth:1016}}>
            <TitleAndSummary {...this.props} {...this.props.project.endProjectReport}/>
          </div>
        ) : null }
      </div>
    );
  }
}

class DesignThinkingProcessOverview extends React.Component {

  render() {
//    let labels=translations.getTranslation(this.props).closeProcess;
    let labels={
      title: "Anbefalte aktiviteter ved utforskning av en idé:",
      help: `Design Thinking er en metodisk tilnærming til utforskning av idé med fem destinkte steg. Det er vanlig å gå frem og tilbake mellom stegene etterhvert som innsikten øker.`,
      activities: {
        empatize: {
          title: "Emapati",
          help: "Skape innsikt i brukerens situasjon gjennom intervjuer, observasjoner og sette deg inn i brukerens situasjon for å forstå hva de trenger, ønsker, oppfører seg, føler, tenker og hvorfor de oppfører seg, følelser og tanker med interaksjon med produkter i reelle situasjoner. Dette omtales ofte som å 'gå i andres sko'."
        },
        define: {
          title: "Definere",
          help: "Etablere en problembeskrivelse gjennom å samle innsikten fra 'Empati'-arbeidet."
        },
        ideate: {
          title: "Idéutvikling",
          help: "Tenke utenfor boksen og identifiser mulige løsninger på problembeskrivelsen."
        },
        prototype: {
          title: "Prototype",
          help: "Eksperimenter med mulige løsninger gjennom utvikling av raske og billige prototyper."
        },
        test: {
          title: "Teste",
          help: "Prøv ut prototyper på relle brukere i relle situasjoner"
        },
      },
      nextStep: {
        title: "Realiser løsning"
      }
    };

    let access=this.props.access;
    let activities=[
      {
        name: "empatize",
        link: "",
        status: "notStarted"
      }, {
        name: "define",
        link: "",
        status: "notStarted"
      }, {
        name: "ideate",
        link: "",
        status: "notStarted"
      }, {
        name: "prototype",
        link: "",
        status: "notStarted"
      }, {
        name: "test",
        link: "",
        status: "notStarted"
      }
    ].filter(item=>item!==undefined);
    let nextStep= {
      link: "/projects/"+this.props.project.id+"/"
    };
    return (
      <div>
        <div style={{maxWidth:800, paddingBottom:30, fontStyle:"italic"}}>
          <p><FormattedContent value={this.props.project.background}/></p>
          <p><FormattedContent value={this.props.project.timing}/></p>
        </div>
        <div style={{textAlign:"center"}}>
          <img src="http://www.theagileelephant.com/wp-content/uploads/2018/02/Design-Thinking.png"/>
        </div>
        <ActivityView
          {...this.props}
          activities={activities}
          labels={labels}
          nextStep={nextStep}
          hideThemes={true}
        />
      </div>
    );
  }
}

function assignPriority(item) {
  return item.status!=="Closed"
    ? Object.assign({},item,{row:parseInt(item.priority),column:parseInt(item.severity)})
    :  Object.assign({},item,{row:undefined,column:undefined});
}

export class KeyInfo extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    var executive=this.props.stakeholders!==undefined ? this.props.stakeholders.filter(stakeholder=>stakeholder.role==="Excecutive" || stakeholder.role==="Senior Responsible Owner").map(person=>person.name).join(", ") : undefined;
    var pManager=this.props.stakeholders!==undefined ? this.props.stakeholders.filter(stakeholder=>stakeholder.role==="Project Manager" || stakeholder.role==="Product Manager" || stakeholder.role==="Programme Manager").map(person=>person.name).join(", ") : undefined;
    var executiveLabel=this.props.isProgramme===true ? labels.general.sro : labels.general.executive;
    var pmLabel=this.props.isProgramme===true ? labels.general.programmeManager : labels.general.projectManager;
    return (
      <div style={{backgroundColor:"#ffffff", border:"1px solid #D1D5DB", borderRadius:"10px", padding:20, marginBottom:20, minWidth: 420, float:"right" }}>

        <div style={{fontSize:22, paddingBottom:10, width:"100%", textAlign: "center", fontWeight:"bold"}}> {labels.keyInformation.keyInformation} <br/>
        </div>

          <div style={{display:"table", width:380, marginLeft:20, marginRight:20, marginTop:10, float: "center",  borderCollapse:"collapse"}}>

            <div style={{display: "table-row", borderBottom:"solid 1px #D1D5DB"}}>
              <div style={{display:"table-cell", textAlign: "left",padding:5}}> {labels.keyInformation.identifier}: </div>
              <div style={{display:"table-cell", textAlign: "left",padding:5}}> {this.props.identifier} </div>
            </div>

            <div style={{display: "table-row", borderBottom:"solid 1px #D1D5DB"}}>
              <div style={{display:"table-cell", textAlign: "left",padding:5}}>{executiveLabel}:</div>
              <div style={{display:"table-cell", textAlign: "left",padding:5}}>{executive}  </div>
            </div>

            <div style={{display: "table-row", borderBottom:"solid 1px #D1D5DB"}}>
              <div style={{display:"table-cell", textAlign: "left",padding:5}}>{pmLabel}:</div>
              <div style={{display:"table-cell", textAlign: "left",padding:5}}>{pManager}  </div>
            </div>

            {this.props.isProgramme || this.props.isProduct || this.props.isRelease ? (null) : (
            <div style={{display: "table-row"     }}>
              <div style={{display:"table-cell", textAlign: "left",padding:5}}>{labels.keyInformation.projectStage}:</div>
              <div style={{display:"table-cell", textAlign: "left",padding:5}}>{this.props.phase}  </div>
            </div>
            )}

          </div>
      </div>
    );
  }
}

export class StatusSummary extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let itemType=
      this.props.isProgramme===true
        ? "/programmes/"
        : this.props.isProduct===true
          ? "/products/"
          : this.props.isRelease===true
            ? "/releases/"
            : "/projects/";
    return (
      <div style={{backgroundColor:"#ffffff", border:"1px solid #D1D5DB", borderRadius:"10px", padding:20, marginBottom:20, marginRight:80, textAlign: "center", minWidth: 420}}>
        <div style={{fontSize:22, paddingBottom:10, width:"100%", fontWeight:"bold", textAlign: "center"}}> {labels.status.summaryStatus} &nbsp;  <StatusIndicator {...this.props.overallStatus}/> <br/> </div>

        <a style={{fontFamily:"Lato", fontStyle:"normal", fontWeight:"bold", fontSize:"14px", lineHight:"20px", color:"#9a9eb1"}} href={itemType+this.props.id+"/reports/"}> {labels.reports.highlightReport}</a>
          <div style={{display:"table", marginTop:20, float: "center",  float: "center", borderCollapse:"collapse"}}>
            <div style={{display: "table-row", fontWeight: "bold"}}>
              <div style={{display:"table-cell", width:60,textAlign: "center",padding:5}}><StatusIndicator {...this.props.benefits}/></div>
              <div style={{display:"table-cell", width:60,textAlign: "center",padding:5}}><StatusIndicator {...this.props.time}/> </div>
              <div style={{display:"table-cell", width:60,textAlign: "center",padding:5}}><StatusIndicator {...this.props.cost}/> </div>
              <div style={{display:"table-cell", width:60,textAlign: "center",padding:5}}><StatusIndicator {...this.props.quality}/></div>
              <div style={{display:"table-cell", width:60,textAlign: "center",padding:5}}><StatusIndicator {...this.props.scope}/>  </div>
              <div style={{display:"table-cell", width:60,textAlign: "center",padding:5}}><StatusIndicator {...this.props.risk}/> </div>
            </div>
            <div style={{display: "table-row", fontWeight: "bold"}}>
              <div style={{display:"table-cell", textAlign: "center",padding:5}}>{labels.status.benefits}</div>
              <div style={{display:"table-cell", textAlign: "center",padding:5}}>{labels.status.time}  </div>
              <div style={{display:"table-cell", textAlign: "center",padding:5}}>{labels.status.cost} </div>
              <div style={{display:"table-cell", textAlign: "center",padding:5}}>{labels.status.quality}</div>
              <div style={{display:"table-cell", textAlign: "center",padding:5}}>{labels.status.scope}  </div>
              <div style={{display:"table-cell", textAlign: "center",padding:5}}>{labels.status.risk}  </div>
            </div>
          </div>

      </div>
    );
  }
}


export class ProjectDetails extends React.Component {



  isBusinessCaseEnabled() {
    return Access.isBusinessCaseEnabled({project:this.props.project.settings,tenant:this.props.tenant.settings});
/*
    let disabledInTenant=this.props.tenant.settings!==undefined && this.props.tenant.settings.disableBusinessCase===true;
    let useBusinessCaseInProject=this.props.project.settings!==undefined && this.props.project.settings.useBusinessCase;
    return this.props.project.settings===undefined && !disabledInTenant || useBusinessCaseInProject===true || useBusinessCaseInProject===undefined;
*/
  }

  isQualityEnabled() {
    return this.props.project.settings===undefined || this.props.project.settings!==undefined && this.props.project.settings.disabledQuality!==true;
  }

  isDefinitionEnabled() {
    return this.props.project.settings===undefined || this.props.project.settings!==undefined && this.props.project.settings.disabledDefinition!==true;
  }

  isProjectBriefEnabled() {
    let enabledInSettings=this.props.project.settings!==undefined
      && this.props.project.settings.reports!==undefined
      && this.props.project.settings.reports.projectBrief;
    return enabledInSettings || this.props.fullOverview!==undefined
  }

  isPIDEnabled() {
    let enabledInSettings=this.props.project.settings!==undefined
      && this.props.project.settings.reports!==undefined
      && this.props.project.settings.reports.PID;
    return enabledInSettings || this.props.fullOverview!==undefined
  }

  hasApprovedBrief() {
    return (
      this.props.project.brief!==undefined
      && this.props.project.brief.history!==undefined
      && this.props.project.brief.history.length>0
    );
  }

  hasApprovedPID() {
    return (
      this.props.project.pid!==undefined
      && this.props.project.pid.history!==undefined
      && this.props.project.pid.history.length>0
    );
  }


  showStartupProcessView() {
    return this.props.showProgress==="startup"
      || this.isProjectBriefEnabled() && this.props.project.version===2
        && !this.hasApprovedBrief() && !this.hasApprovedPID() && !this.props.project.isCompleted;
  }

  showInitiationProcessView() {
    return !this.props.project.isCompleted && (this.props.showProgress==="initiation"
      || this.isPIDEnabled() && this.props.project.version===2
      && this.hasApprovedBrief() && !this.hasApprovedPID());
  }

  render() {
    var issues=(this.props.project.issues!==undefined ? this.props.project.issues : []);
    var issueItems=issues.slice(0).map(assignPriority);

    var portfolio=this.props.portfolio!==undefined ? this.props.portfolio :
      this.props.project!==undefined && this.props.project.portfolio!==undefined && this.props.tenant.portfolios!==undefined ?
        this.props.tenant.portfolios.filter(portfolio=>portfolio.id===this.props.project.portfolio)[0] : undefined;

    let labels=translations.getTranslation(this.props);
    let riskItems=this.props.project.risks!==undefined ? this.props.project.risks : [];

    let access={
      isBusinessCaseEnabled: this.isBusinessCaseEnabled.bind(this),
      isQualityEnabled: this.isQualityEnabled.bind(this),
      isDefinitionEnabled: this.isDefinitionEnabled.bind(this),
      isProjectBriefEnabled: this.isProjectBriefEnabled.bind(this),
      isPIDEnabled : this.isPIDEnabled.bind(this)
    };
    return (
      <div style={{marginTop: 40, marginLeft:30, fontFamily:"Lato"}}>
        {this.props.project.isStopped ? <span style={{color:"red", paddingRight:20}}>STOPPED</span> :null}
        {this.props.project.isPaused ? <span style={{color:"red", paddingRight: 20}}>paused</span> :null}

        <div>
            <div style={{fontWeight:"bold", fontSize:14 }}>
              {portfolio!==undefined ? portfolio.name : null}
            </div>
            <div style={{fontSize:30, marginBottom:30, width:"100%", fontWeight:"bold", float:"left"}}>
              {this.props.project.name}
            </div>

          <div style={{display:"inline-block", maxWidth:1016}}>

            <div style={{display: this.props.showProgress==="designThinking" ? "none" : "flex", padding:0, marginBottom:10, justifyContent: "space-between", flexWrap:"wrap"}}>
              <StatusSummary {...this.props.project}   {...this.props}/>
              <KeyInfo {...this.props.project}   {...this.props}/>
            </div>

            { this.props.showProgress==="designThinking" ? (
              <DesignThinkingProcessOverview {...this.props} access={access}/>
            ) : this.props.project.isClosing ? (
              <CloseProjectProcessOverview {...this.props} access={access}/>
            ) : this.showInitiationProcessView() ? (
              <InitiationProcessOverview {...this.props} access={access}/>
            ) : this.showStartupProcessView() ? (
              <StartUpProcessOverview {...this.props} access={access}/>
            ) : (
              <div>
                <table style={{paddingTop: 20, width:"100%", maxWidth:1016, borderSpacing: 15}}>
                  <tbody>
                  <tr>
                    <td>
                      <Themes {...this.props} access={access}/>
                    </td>
                  </tr>
                  </tbody>
                </table>
                {this.props.project.isCompleted===true && this.props.project.endProjectReport!==undefined ? (
                  <div style={{maxWidth:1016}}>
                    <TitleAndSummary {...this.props} {...this.props.project.endProjectReport}/>
                  </div>
                ) : null}
              </div>
            )}

            <div style={{display: this.props.showProgress==="designThinking" ? "none" : "flex", marginTop:10, justifyContent: "space-evenly", flexWrap:"wrap"}}>
              <div style={{textAlign: "center"}}>
                <b>{labels.general.risks}</b> <br/> <br/>
                <RiskTable
                  {...this.props}
                  items={riskItems}
                  />
              </div>
              <div style={{textAlign: "center"}}>
                <b>{labels.general.issues} </b><br/> <br/>
                <IssueTable
                  {...this.props}
                  items={issueItems}
                  />
              </div>
            </div>

          </div>
          {this.props.showProgress!=="designThinking" ? (
            <Links
              {...this.props}
              {...this.props.project}
              standardLinks={this.props.tenant.standardLinks}
              mode={this.props.linkMode}
              edit={this.props.edit}
              add={this.props.add}
              briefEnabled={this.isProjectBriefEnabled()}
              pidEnabled={this.isPIDEnabled()}
            />
          ) : null}
        </div>

        <Performance {...this.props}/>

      </div>
    );
  }
}

class PerformanceDetails extends React.Component {
  render() {
    let size=JSON.stringify(this.props).length;
    const sortBySize=(a,b)=>{
      let sizeA=JSON.stringify(this.props[a]).length;
      let sizeB=JSON.stringify(this.props[b]).length;
      return sizeA<sizeB ? 1 : sizeA>sizeB ? -1 : 0;
    }
    return (
      <div>
        <div>
          {Object.keys(this.props).sort(sortBySize).map(key=>(
            <div style={{display: "flex"}}>
              <b>{key}:</b>
              <Performance {...this.props[key]}
                length={JSON.stringify(this.props[key]).length}
                size={size}
                showSizeOfResponse={true}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

class Performance extends React.Component {
  constructor(props) {
    super(props);
    this.state={details:false}
  }

  toggleState(event) {
    this.setState({details:!this.state.details});
  }

  render() {
    return !this.props.showSizeOfResponse ? null : this.state.details ? (
      <div>
        <div style={{cursor:"pointer"}} onClick={this.toggleState.bind(this)}>- {JSON.stringify(this.props).length}</div>
        <PerformanceDetails {...this.props}/>
      </div>
    ) : (
      <div style={{cursor:"pointer"}} onClick={this.toggleState.bind(this)}>
        + {this.props.size!==undefined && this.props.length!==undefined ? (
          <span>
            ({this.props.length}{this.props.size!==undefined?", "+(parseInt(this.props.length)/parseInt(this.props.size)*100).toFixed(2)+"%":""})
          </span>
        ) : null}
      </div>
    );
  }
}

export default class ProjectDetailsPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <ProjectDetails {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/ProjectDetails.jsx